import {
	DATAPOINT_BUTTON_COLOR1,
	DATAPOINT_BUTTON_COLOR2,
	DATAPOINT_BUTTON_FREQUENCY1,
	DATAPOINT_BUTTON_FREQUENCY2,
	DATAPOINT_IS_ONLINE,
	DATAPOINT_LED_COLOR,
	DATAPOINT_LED_FREQUENCY,
	DATAPOINT_PIN1_FREQUENCY,
	DATAPOINT_PIN2_FREQUENCY,
	DATAPOINT_PIN3_FREQUENCY,
	DATAPOINT_PIN4_FREQUENCY
} from '../../modules/common/consts';
import {AssetLiveData} from '../widgets/common/useAssetSubscription';

const mapLiveDataOnlineBased = (assetLiveData: AssetLiveData): AssetLiveData => {
	const isOnline = assetLiveData[DATAPOINT_IS_ONLINE];
	return Object.keys(assetLiveData).reduce((liveData: Record<string, any>, dataPointName) => {
		switch (dataPointName) {
			case DATAPOINT_IS_ONLINE:
				liveData[dataPointName] = assetLiveData[dataPointName];
				break;

			case DATAPOINT_PIN1_FREQUENCY:
			case DATAPOINT_PIN2_FREQUENCY:
			case DATAPOINT_PIN3_FREQUENCY:
			case DATAPOINT_PIN4_FREQUENCY:
			case DATAPOINT_LED_FREQUENCY:
			case DATAPOINT_BUTTON_FREQUENCY1:
			case DATAPOINT_BUTTON_FREQUENCY2:
				liveData[dataPointName] = isOnline ? assetLiveData[dataPointName] : 0;
				break;

			case DATAPOINT_LED_COLOR:
			case DATAPOINT_BUTTON_COLOR1:
			case DATAPOINT_BUTTON_COLOR2:
				liveData[dataPointName] = isOnline ? assetLiveData[dataPointName] : '#666666';
				break;

			default:
				liveData[dataPointName] = isOnline ? assetLiveData[dataPointName] : '';
				break;
		}

		return liveData;
	}, {});
};

export {mapLiveDataOnlineBased};
